exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-wrapper {\n    margin: 15px;\n}\n\n.card-separator {\n    margin: 15px 0;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/shane/workspace/website/website-client/src/app/contact/contact.component.css
// module id = ../../../../../src/app/contact/contact.component.css
// module chunks = main